import React from 'react';
import t from 'prop-types';

var ContenidoVentana = function ContenidoVentana(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'contenidosVentana'
  }, children);
};

ContenidoVentana.propTypes = process.env.NODE_ENV !== "production" ? {
  children: t.any
} : {};
export default ContenidoVentana;